<small
  *ngIf="formCtrl.errors?.required && (formCtrl.dirty || formCtrl.touched)"
  class="p-invalid"
  >{{ errorMsg }}</small
>
